import { useState, useCallback } from 'react';
import {
  type DermatologiaData,
  emptyDermatologiaData,
} from './types';

export const useDermatologiaForm = () => {
  const [dermatologiaData, setDermatologiaData] = useState<DermatologiaData>(emptyDermatologiaData);

  const setDermatologiaField = useCallback(
    (section: keyof DermatologiaData, field: string, value: any) => {
      setDermatologiaData(prev => ({
        ...prev,
        [section]: {
          ...(prev[section] as any),
          [field]: value,
        },
      }));
    },
    [],
  );

  const loadFromConsultation = (rawData: any) => {
    const raw = (rawData as any)?.dermatologia;
    if (!raw) return;

    const parsed: DermatologiaData = {
      ...emptyDermatologiaData,
      ...raw,
      lesion: { ...emptyDermatologiaData.lesion, ...(raw.lesion || {}) },
      history: { ...emptyDermatologiaData.history, ...(raw.history || {}) },
      dermoscopy: { ...emptyDermatologiaData.dermoscopy, ...(raw.dermoscopy || {}) },
      treatment_derma: { ...emptyDermatologiaData.treatment_derma, ...(raw.treatment_derma || {}) },
    };

    setDermatologiaData(parsed);
  };

  const getPayloadData = (): DermatologiaData | null => {
    const hasData =
      dermatologiaData.lesion.type !== '' ||
      dermatologiaData.history.onset !== '' ||
      dermatologiaData.dermoscopy.performed ||
      dermatologiaData.treatment_derma.topical !== '';
    return hasData ? dermatologiaData : null;
  };

  return {
    dermatologiaData,
    setDermatologiaData,
    setDermatologiaField,
    loadFromConsultation,
    getPayloadData,
  };
};
